import type { EmpPersonCard } from "./people";
import type { EmpResourceFileType, EmpResourceKind } from "./resources";

/**
 * Header search across skyEmployee (decision P3-2): people, posts and
 * resources (Phase 6). Every group follows the
 * same rules as its own page, so search never shows what the caller can't see.
 */
export interface EmpSearchPost {
  id: string;
  type: string;
  title: string | null;
  snippet: string;
  authorName: string;
}

export interface EmpSearchResource {
  id: string;
  title: string;
  kind: EmpResourceKind;
  fileType: EmpResourceFileType | null;
  categoryName: string;
  versionPublishedAt: string;
}

export interface EmpSearchResults {
  people: EmpPersonCard[];
  posts: EmpSearchPost[];
  resources: EmpSearchResource[];
}

export const SEARCH_MIN_LENGTH = 2;
export const SEARCH_MAX_LENGTH = 100;
export const SEARCH_PEOPLE_LIMIT = 4;
export const SEARCH_POSTS_LIMIT = 3;
export const SEARCH_RESOURCES_LIMIT = 3;
